import React, { useEffect, useState } from "react";
import "../styles/components/LeydenBanner.scss";
import { Banner } from "@els/els-react--banner";
const LeydenBanner = (props: any) => {
  const [showAlert, setShowAlert] = useState(true);
  return (
    <>
      {showAlert ? (
        <div>
          <Banner
            isVisible={true}
            type={"success"}
            onClose={() => {
              setShowAlert(false);
              if (props?.onIconClose) {
                props.onIconClose();
              }
            }}
            hideCloseLabel={true}
          >
            {props.children}
          </Banner>
        </div>
      ) : null}
    </>
  );
};

export default LeydenBanner;
